import styled from 'styled-components6';
import { Chip as ChipTypography } from '../../../../theme';

const Chip = styled(ChipTypography)`
    box-sizing: content-box;
    background: var(--rwl-palette-gray-200);
    border-radius: 48px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: var(--rwl-spacing-xs) var(--rwl-spacing-sm);
    height: 18px;
    display: inline-block;
    margin-right: var(--rwl-spacing-sm);
    color: var(--rwl-text-default);
    white-space: nowrap;
`;

type LabelProps = {
    name: string;
};

export const Label = ({ name }: LabelProps): JSX.Element => {
    return <Chip>{name}</Chip>;
};
